import { FinancialAccountSourceType } from "@common/types/financialAccount";

export const INVOICE_ACCOUNT_FILTER_SOURCE_TYPES = [
    FinancialAccountSourceType.STRIPE,
    FinancialAccountSourceType.MERCURY,
    FinancialAccountSourceType.BILLCOM,
];

// Kick-hosted, SendGrid-verified address used when the invoice is sent from
// Kick rather than a workspace custom sending email. Customer replies still
// go to `replyTo`. Shared so the composer and mailer use the same From.
export const KICK_INVOICE_SENDER_ADDRESS = "invoices@kick.co";
export const KICK_INVOICE_SENDER_DISPLAY_NAME = "Kick Invoicing";

// Subject prefix applied to a native-invoice test send so the recipient's inbox
// visibly distinguishes the preview copy from a real customer send. Carried in
// the test-send job payload (not persisted on the invoice) so the delivered
// email shows the prefix rather than the worker reloading the un-prefixed
// persisted subject.
export const NATIVE_INVOICE_TEST_SUBJECT_PREFIX = "[TEST] ";

interface InvoiceFromHeaderParams {
    displayName: string;
    email: string;
}

export function formatInvoiceFromHeader({
    displayName,
    email,
}: InvoiceFromHeaderParams): string {
    // Strip characters that could break out of the quoted display-name and
    // inject additional headers: double-quotes plus CR/LF and other control
    // characters. `displayName` is user-controlled (e.g. fromBusinessName), so
    // sanitize here rather than relying solely on the downstream mailer.
    // eslint-disable-next-line no-control-regex
    const safeDisplayName = displayName.replace(/["\x00-\x1F\x7F]/g, "");
    return `"${safeDisplayName}" <${email}>`;
}

export const KICK_INVOICE_FROM_HEADER = formatInvoiceFromHeader({
    displayName: KICK_INVOICE_SENDER_DISPLAY_NAME,
    email: KICK_INVOICE_SENDER_ADDRESS,
});
